export default __webpack_public_path__ + "static/media/G89A8020copy_tn.f6b1a6f9.jpg";